var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73216",
    "data-name": "Group 73216",
    transform: "translate(-22470 3668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156770",
    "data-name": "Rectangle 156770",
    width: 48,
    height: 48,
    transform: "translate(22470 -3668)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "X_logo_1",
    "data-name": "X logo 1",
    d: "M26.049,19.872,40.462,2.936H37.047L24.529,17.642l-10-14.706H3L18.119,25.174,3,42.936H6.416l13.218-15.53,10.558,15.53H41.727Zm-4.679,5.5-1.532-2.214L7.643,5.535h5.252l9.836,14.221,1.532,2.215L37.048,40.453H31.8L21.367,25.372Z",
    transform: "translate(22471.5 -3666.936)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.f96d4e1515aac8ba7cb5b30bbe37dd3d.svg";
export { ForwardRef as ReactComponent };